import { APIGet, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { IBookingEngine } from "redux/reducers/bookingEngine";

export interface IBookingWindow {
  id: number;
  booking_engine_id: number;
  title: string;
  days_in_advance_start: number;
  days_in_advance_end: number;
  open_time: string;
  open_structure: string;
  booking_engine: IBookingEngine;
}

interface IGetBookingWindow {
  booking_engine_id?: string;
  extended?: boolean;
}

// GET Booking Window
export async function GetBookingWindow(params: IGetBookingWindow, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IBookingWindow[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/booking-engine/window"),
    params,
    useGlobalLoader,
    token,
  );
}

interface IPutBookingWindow {
  id: number;
  days_in_advance_start?: number;
  days_in_advance_end?: number;
  open_time?: string;
  open_structure?: string;
}
// PUT Booking Window
export async function PutBookingWindow(params: IPutBookingWindow, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/booking-engine/window"), params, useGlobalLoader);
}
